module.exports = __webpack_public_path__ + "static/media/linkedin-red.97931861.png";